// frontend/modules/customer-notification/index.ts
import { ModuleConfig } from '@/core/module';
import { notificationRoutes } from './routes';
import { useNotificationStore } from './stores/notification-store';
import { useReminderSchedulerStore } from './stores/reminder-scheduler-store';

export const CustomerNotificationModule: ModuleConfig = {
    name: 'customer-notification',
    routes: notificationRoutes,
    stores: {
        notification: useNotificationStore,
        reminderScheduler: useReminderSchedulerStore
    },
    initialize: () => {
        console.log('Customer Notification module initialized');
    }
};